export default {"src":"/_next/static/media/guidance.mono.eb6c560e.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};